<script lang="ts">
  import SweatDrop from '../../../../assets/svgs/sweat-drop.svelte';
  export let title: string;
  export let subTitle: string;
  export let fontSize: string;
</script>

<div class="flex items-center flex-col h-full w-full py-20 px-4 sm:py-48 lg:px-0 justify-center">
  <SweatDrop svgClass={'scale-50 sm:scale-100'} />
  <h1
    class="text-center text-sweat-gray-30 text-display-md sm:text-display-2xl font-bold max-w-800"
  >
    {title}
  </h1>
  <p class="{fontSize} text-center text-sweat-gray-40 text-lg sm:text-display-xs my-8 max-w-800">
    {subTitle}
  </p>
  <div class="flex flex-col items-center justify-center sm:flex-row w-full sm:w-auto">
    <slot />
  </div>
</div>
